import { render, staticRenderFns } from "./PlanReport.vue?vue&type=template&id=82ffb0a4&scoped=true"
import script from "./PlanReport.vue?vue&type=script&lang=js"
export * from "./PlanReport.vue?vue&type=script&lang=js"
import style0 from "./PlanReport.vue?vue&type=style&index=0&id=82ffb0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ffb0a4",
  null
  
)

export default component.exports